// =============================================================================
// SellerAnalytics constants + math helpers
// =============================================================================

import { C } from "../../lib/theme";

// KPI status tones — used by KpiBox + MetricRow.
// Was previously defined as a local const inside KpiBox.jsx; MetricRow
// referenced it without importing → "STATUS_TONES is not defined" at runtime.
export const STATUS_TONES = {
  great: { bg: C.greenBg, fg: C.greenDk, label: "Strong" },
  good:  { bg: C.blueBg,  fg: C.blueDk,  label: "OK" },
  warn:  { bg: C.amberBg, fg: C.amberDk, label: "Needs work" },
};

// Delivery method swatch colors + labels — used by DeliveryDonut. Was
// previously orphaned at the bottom of RevenueChart.jsx (auto-extractor
// fallout); moved here so it lives next to its only consumer.
export const DELIVERY_COLORS = {
  pickup: C.hunter,
  self: C.hunterLt,
  courier: C.amber,
  unknown: C.dustDk,
};

export const DELIVERY_LABEL = {
  pickup: "Pickup",
  self: "Self-delivery",
  courier: "Courier",
  unknown: "Unspecified",
};

export const RANGES = [
  { id: "today", label: "Today",          days: 1 },
  { id: "7d",    label: "Last 7 days",    days: 7 },
  { id: "30d",   label: "Last 30 days",   days: 30 },
  { id: "90d",   label: "Last 90 days",   days: 90 },
  { id: "all",   label: "All time",       days: null },
];

// Sub-order statuses that count as *earned* revenue.
export const EARNED = new Set(["delivered", "completed"]);

// Sub-order statuses that count as *lost* (voided) revenue.
export const VOIDED = new Set(["cancelled", "refunded", "payment_failed", "payment_timeout"]);

export function startOfRange(days) {
  if (days == null) return null;
  const d = new Date();
  if (days === 1) {
    d.setHours(0, 0, 0, 0);
    return d;
  }
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() - (days - 1));
  return d;
}

export function niceMax(v) {
  if (v <= 0) return 1;
  const pow = Math.pow(10, Math.floor(Math.log10(v)));
  const n = v / pow;
  const bump = n <= 1 ? 1 : n <= 2 ? 2 : n <= 5 ? 5 : 10;
  return bump * pow;
}

export function growthPct(current, prev) {
  if (prev === 0) return current > 0 ? 100 : 0;
  return ((current - prev) / prev) * 100;
}
